export default {
  sidebar: {
    roles: 'Roles',
    roleGroups: 'Grupos de Roles',
    users: 'Usuarios',
    userGroups: 'Grupos de Usuarios',
    approvals: 'Aprobaciones',
  },
};
